import FeedviewsList from './FeedviewsList';

export default FeedviewsList;
